import { Box, Stack } from "@mui/material";
import AuthLeftBlue from "components/screen/phase-3/AuthLeftRight/AuthLeftBlue";
import AuthRightWrap from "components/screen/phase-3/AuthLeftRight/AuthRightWrap";
import SignupForm from "components/widgets/phase-3/AuthRight/RightSignup/SignupForm";
import SignupLoginHead from "components/widgets/phase-3/AuthRight/SignupLoginHead";

const SignupContainer = () => {
  return (
    <Box width={"100%"} height={"100vh"} display={"flex"}>
      <AuthLeftBlue sx={{ display: { xs: "none", md: "block" } }} />
      <AuthRightWrap>
        <Stack
          width={"100%"}
          height={"100%"}
          alignItems={"center"}
          justifyContent={"center"}
          sx={{ p: { xs: 5, md: 15 } }}
        >
          {/* Main Box */}
          <Stack spacing={4}>
            {/* Form Section */}
            <Stack spacing={2}>
              {/* Head */}
              <SignupLoginHead
                head={"Create An Account For Your Company"}
                desc={`With this account for your company you could assess, monitor & report. Develop ESG Strategy and improve your ESG Rating, thereby, making your business more sustainable and contribute to the global push to “Net Zero”.`}
              />
            </Stack>

            {/* Form */}
            <SignupForm />
          </Stack>
        </Stack>
      </AuthRightWrap>
    </Box>
  );
};
export default SignupContainer;
